/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PbjHoursResponse } from '../api-models';
/**
 * PbjApi - axios parameter creator
 * @export
 */
export const PbjApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pbjPBJHoursGet: async (employeeId: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('pbjPBJHoursGet', 'employeeId', employeeId)
            const localVarPath = `/Pbj/PBJHours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PbjApi - functional programming interface
 * @export
 */
export const PbjApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PbjApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pbjPBJHoursGet(employeeId: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbjHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pbjPBJHoursGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PbjApi - factory interface
 * @export
 */
export const PbjApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PbjApiFp(configuration)
    return {
        /**
         * 
         * @param {PbjApiPbjPBJHoursGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pbjPBJHoursGet(requestParameters: PbjApiPbjPBJHoursGetRequest, options?: AxiosRequestConfig): AxiosPromise<PbjHoursResponse> {
            return localVarFp.pbjPBJHoursGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pbjPBJHoursGet operation in PbjApi.
 * @export
 * @interface PbjApiPbjPBJHoursGetRequest
 */
export interface PbjApiPbjPBJHoursGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PbjApiPbjPBJHoursGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof PbjApiPbjPBJHoursGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof PbjApiPbjPBJHoursGet
     */
    readonly endDate?: string
}

/**
 * PbjApi - object-oriented interface
 * @export
 * @class PbjApi
 * @extends {BaseAPI}
 */
export class PbjApi extends BaseAPI {
    /**
     * 
     * @param {PbjApiPbjPBJHoursGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PbjApi
     */
    public pbjPBJHoursGet(requestParameters: PbjApiPbjPBJHoursGetRequest, options?: AxiosRequestConfig) {
        return PbjApiFp(this.configuration).pbjPBJHoursGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
